/* eslint-disable import/prefer-default-export */
import React, { useEffect } from 'react'

import { useTranslatedText } from './StaticTextContext'

interface OracleErrorToastProps {
  isVisible: boolean
  onClose: () => void
  message?: string
}

export const OracleErrorToast: React.FC<OracleErrorToastProps> = ({
  isVisible,
  onClose,
  message,
}) => {
  const defaultErrorMessage = useTranslatedText({ keys: ['errors', 'generalError'] })
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose()
      }, 4000) // Auto-dismiss after 4 seconds

      return () => clearTimeout(timer)
    }
    return undefined
  }, [isVisible, onClose])

  if (!isVisible) {
    return null
  }

  return (
    <div className="oracle-error-toast">
      <div className="oracle-error-toast__container">
        <div className="oracle-error-toast__content">
          <div className="oracle-error-toast__message">
            {message || defaultErrorMessage}
          </div>
        </div>
      </div>
    </div>
  )
}
